import { forwardRef } from "react";
const SvgDoing2 = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="m 11.840498,8.4684285 v 4.1003855 h 4.100386" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" id="path2" /></svg>;
const ForwardRef = forwardRef(SvgDoing2);
export default ForwardRef;